import React, { Component } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Button,
  Row,
  Col,
} from 'reactstrap';
import IntlMessage from "../../../helpers/intlMessage";

function ModalConfirmar ({
  showModalConfirmar, 
  toggleModalConfirmar, 
  type='confirm', 
  backdrop=false, 
  keyboard=true, 
  close,
  cancelar,
  disabled,
  color,
  mensagem, 
  titulo,
  confirmar,
  //onConfirmar,
}) {

    return (
      <Modal
        className='modal-confirm'
        backdrop={backdrop}
        keyboard={keyboard}
        centered
        isOpen={showModalConfirmar}
        toggle={toggleModalConfirmar}
      >
        <ModalHeader
          toggle={
            !close
              ? toggleModalConfirmar
              : close
          }
        >
          {titulo}
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <FormGroup
                className={`confirmar-^${!color ? 'primary' : color
                  }`}
              >
                <Label>{mensagem}</Label>
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={
              !cancelar
                ? toggleModalConfirmar
                : cancelar
            }
            className={`button-cancel-${type}`}
            color='secondary'
          >
            <IntlMessage id="dashboards.examDetails.cancel" />
          </Button>
          <Button
            className={`button-confirm-${type}`}
            onClick={
              //onConfirmar();
              !confirmar
                ? toggleModalConfirmar
                : confirmar
            }
            disabled={disabled}
            color='primary'
          >
            {type == 'confirm' ? 'Confirmar' : 'OK'}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }

export default ModalConfirmar;



// WEBPACK FOOTER //
// ./src/app/common/modalConfirmar/modalConfirmar.js